import { render, staticRenderFns } from "./evaluateDetail.vue?vue&type=template&id=515648d2&scoped=true&"
import script from "./evaluateDetail.vue?vue&type=script&lang=ts&"
export * from "./evaluateDetail.vue?vue&type=script&lang=ts&"
import style0 from "./evaluateDetail.vue?vue&type=style&index=0&id=515648d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515648d2",
  null
  
)

export default component.exports